@let showWorkedHours = showWorkedHours$ | async;
@let showNextPaymentDate = showNextPaymentDate$ | async;

<div class="main-container">
  <div class="form-my-work">
    @if (workSandbox.workHistoryLoading$ | async) {
      <div class="loading-container">
        <ion-skeleton-text style="height: 140px" />
        <ion-skeleton-text style="height: 60px" />

        <div class="item"><div class="left"><ion-skeleton-text class="rounded" /></div><div class="right"><ion-skeleton-text /></div></div>
        <div class="item"><div class="left"><ion-skeleton-text class="rounded" /></div><div class="right"><ion-skeleton-text /></div></div>
        <div class="item"><div class="left"><ion-skeleton-text class="rounded" /></div><div class="right"><ion-skeleton-text /></div></div>
        <div class="item"><div class="left"><ion-skeleton-text class="rounded" /></div><div class="right"><ion-skeleton-text /></div></div>

        <ion-skeleton-text style="height: 140px" />

        <div>
          <ion-skeleton-text style="width: 50%; height: 25px" />
          <ion-skeleton-text style="width: 80%; height: 35px" />
        </div>
      </div>
    } @else {
      <div class="tabs-container">
        @if (showWorkedHours.showWorkedHoursLastWeek) {
          @if (previousWeek$ | async; as previousWeek) {
            <c-work-progress-bar [historyItem]="previousWeek"></c-work-progress-bar>
            <div class="label1">{{ 'my-work.worked-last-week' | transloco }}</div>
          } @else {
            <div class="no-work-history">{{ 'my-work.no-work-history' | transloco }}</div>
          }
        }

        @if (payslipFeatureFlag() || invoiceFeatureFlag()) {
          <div class="latest-buttons">
            @if (payslipFeatureFlag()) {
              <c-button
                type="secondary"
                (action)="openLatestPayslip()"
                [loading]="workSandbox.isLoadingLatestPayslip">
                {{ 'my-work.show-latest-payslip' | transloco }}
              </c-button>
            }

            @if (invoiceFeatureFlag()) {
              <c-button
                type="secondary"
                (action)="openLatestInvoice()"
                [loading]="workSandbox.isLoadingLatestInvoice">
                {{ 'my-work.show-latest-invoice' | transloco }}
              </c-button>
            }

          </div>
        }
        <div class="tiles-container">
          @if (timeRegistrationFeatureFlag()) {
            <c-list-button
              [label]="'my-work.hour-registration' | transloco"
              (clicked)="navigateToTimeRegistration()"
              data-test-id="worked-hours-and-payments-component.time-registration.navigation-menu-item">
              <c-icon [icon]="hourRegistrationIcon" slot="start" color="brand-shade" size="xl" />
            </c-list-button>
          }

          @if (expensesFeatureFlag()) {
            <c-list-button
              [label]="'my-work.expenses' | transloco"
              (clicked)="navigateToExpenses()"
              data-test-id="worked-hours-and-payments-component.expenses.navigation-menu-item">
              <c-icon [icon]="expensesIcon" slot="start" color="brand-shade" size="xl" />
            </c-list-button>
          }

          @if (requestsFeatureFlag()) {
            <c-list-button
              [label]="'my-work.requests' | transloco"
              (clicked)="navigateToRequests()"
              data-test-id="worked-hours-and-payments-component.requests.navigation-menu-item">
              <c-icon [icon]="requestsIcon" slot="start" color="brand-shade" size="xl" />
            </c-list-button>
          }

          @if (balanceFeatureFlag()) {
            <c-list-button
              [label]="'my-work.balance' | transloco"
              (clicked)="navigateToBalance()"
              data-test-id="worked-hours-and-payments-component.balance.navigation-menu-item">
              <c-icon [icon]="balanceIcon" slot="start" color="brand-shade" size="xl" />
            </c-list-button>
          }
        </div>
      </div>

      @if (showWorkedHours.showWorkedHoursPastWeeks || showNextPaymentDate) {
        <div class="dashboard">
          @if (showWorkedHours.showWorkedHoursPastWeeks) {
            <div class="dashboard-title">
              {{ 'my-work.current-week' | transloco }} ({{ 'common.week-abbreviation' | transloco }}{{ currentWeek }})
            </div>
            <c-work-week-overview
              [loading]="workSandbox.workHistoryLoading$ | async"
              [historyItems]="workSandbox.workHistory$ | async"
              (navigateToWeek)="navigateToWeek($event)"
            ></c-work-week-overview>
          }
          @if (showNextPaymentDate) {
            <div class="dashboard-labels">
              <div class="label2">{{ 'my-work.your-next-payment' | transloco }}</div>
              <div class="label3">
                @if (nextPaymentDate$ | async; as paymentDate) {
                  {{ paymentDate }}
                } @else {
                  <div class="label4">
                    {{ 'my-work.your-next-payment.no-date' | transloco }}
                  </div>
                }
              </div>
              <div class="label4">{{ 'my-work.salary-delay-note' | transloco }}</div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
